var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195.76 82.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efd282;}.cls-2{fill:#fff;}.cls-3{fill:#e1e0dd;}.cls-4{fill:none;stroke:#e1e0dd;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.91,3.4H5.82C3.12,3.4,.93,5.95,.93,9.08V74.15c0,3.14,2.19,5.68,4.9,5.68H187.91c2.7,0,4.9-2.54,4.9-5.68V9.08c0-3.14-2.19-5.68-4.9-5.68Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.35,
    y: 2.83,
    width: 191.45,
    height: 77.13,
    rx: 5.96,
    ry: 5.96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.73,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.73,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.51,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.28,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.06,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.84,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.61,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.8,
    y: 21.46,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.17,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.94,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.72,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.9,
    y: 21.46,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.27,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.05,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.83,21.46h15.76c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-15.76c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.73,31.59h11.09c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59H8.73c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.73,41.66h13.61c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59H8.73c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.73,51.73H27.33c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59H8.73c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.73,61.66h11.46c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59H8.73c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.69,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.51,
    y: 41.66,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.21,41.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.27,51.73h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.97,61.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.48,
    y: 61.66,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.08,61.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.42,
    y: 61.66,
    width: 58.63,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 39.85,
    y: 51.73,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.61,51.73h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.78,51.73h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.95,51.73h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.13,51.73h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.3,51.73h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.88,
    y: 51.73,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.64,51.73h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.25,
    y: 61.66,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.43,
    y: 61.66,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.21,61.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 143.8,
    y: 61.66,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.22,
    y: 51.73,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.39,
    y: 51.73,
    width: 20.79,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.31,41.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.41,41.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.52,41.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.62,41.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.73,41.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.83,41.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.34,
    y: 41.66,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.04,41.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.14,41.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.7,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.71,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.72,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.73,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.73,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.74,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.75,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.76,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.77,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.78,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.78,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.79,31.59c-.33,0-.59,.27-.59,.59v7.19c0,.33,.27,.59,.59,.59h2.31c.33,0,.59,.27,.59,.59v8.89c0,.33,.27,.59,.59,.59h5.3c.33,0,.59-.27,.59-.59v-17.26c0-.33-.27-.59-.59-.59h-8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.79,41.66h-6.54c-.33,0-.59,.27-.59,.59v7.19c0,.33,.27,.59,.59,.59h7.19c.33,0,.59-.27,.59-.59v-7.19c0-.33-.27-.59-.59-.59h-.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.33,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.21,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.08,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.96,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.05,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.33,
    y: 8.82,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.8,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.08,
    y: 8.82,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.77,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.05,
    y: 8.82,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.52,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.4,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 157.14,
    y: 8.82,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.25,8.82h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 178.17,
    y: 8.82,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 157.14,
    y: 21.46,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.25,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.76,21.46h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.73,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.25,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.76,31.59h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.25,51.54h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.14,
    y: 61.66,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.25,61.66h7.19c.33,0,.59,.27,.59,.59v7.19c0,.33-.27,.59-.59,.59h-7.19c-.33,0-.59-.27-.59-.59v-7.19c0-.33,.27-.59,.59-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.17,
    y: 61.66,
    width: 8.37,
    height: 8.37,
    rx: 0.59,
    ry: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.f76a3b6d5fac40d1ddb76a4f436753ab.svg";
export { ForwardRef as ReactComponent };